import {
  AccessLevel,
  BecomeAMemberTerm,
  ComparisonItem,
  MembershipType,
  Sys,
} from '@/generated/contentfulTypes';

import { BaseItemProps } from './ItemCard.interface';

type ExtrasType = {
  __typename: 'Extras';
  sys?: Sys;
  title: string;
  description: string;
  price?: number;
};

export type ItemCardTypes =
  | ComparisonItem
  | Partial<BecomeAMemberTerm & { discountedPrice: string }>
  | Partial<AccessLevel>
  | Partial<MembershipType>
  | ExtrasType;

export function mapToBaseItemProps<T extends ItemCardTypes>(
  item: T
): BaseItemProps {
  const base: BaseItemProps = {
    __typename: item?.__typename,
    title: item.title,
    sys: item?.sys,
    description: 'description' in item ? (item as any).description : undefined,
    price: 'price' in item ? (item as any).price : undefined,
  };

  if (item?.__typename === 'ComparisonItem') {
    const comparisonItem = item as ComparisonItem;
    return {
      ...base,
      bannerText: 'bannerText' in item ? item.bannerText : undefined,
      // NOTE: keeping bannerTextLocation commented out as it's not needed for now
      // bannerTextLocation:
      //   'bannerTextLocation' in item
      //     ? (item.bannerTextLocation as BannerTextLocation)
      //     : undefined,
      description: item.body,
      showBanner: true,
      price: comparisonItem.price,
      period: comparisonItem.period,
      additionalSubtext: comparisonItem.additionalSubtext,
      highlightedBenefits: comparisonItem.highlightedBenefitsCollection?.items,
      includedBenefits: comparisonItem.regularBenefitsCollection?.items,
      excludedBenefits: comparisonItem.excludedBenefitsCollection?.items,
    };
  }

  if (item?.__typename === 'BecomeAMemberTerm') {
    const memberTerm = item as BecomeAMemberTerm & {
      price: number;
      discountedPrice?: string;
    };
    return {
      ...base,
      bannerText: 'bannerText' in item ? item.bannerText : undefined,
      // NOTE: keeping bannerTextLocation commented out as it's not needed for now
      //  bannerTextLocation:
      //         'bannerTextLocation' in item
      //           ? (item.bannerTextLocation as BannerTextLocation)
      //           : undefined,
      showBanner: memberTerm.showBanner,
      description: item.body,
      price: memberTerm.price,
      period: memberTerm.paymentTerm,
      highlightedBenefits: memberTerm.highlightedBenefit,
      includedBenefits: memberTerm.includedBenefitsCollection?.items,
      excludedBenefits: memberTerm.excludedBenefitsCollection?.items,
      discountedPrice: memberTerm?.discountedPrice || undefined,
    };
  }

  if (item?.__typename === 'AccessLevel') {
    const accessLevel = item as AccessLevel;
    return {
      ...base,
      description: accessLevel.description,
      highlightedBenefits: accessLevel.highlightedBenefit,
      includedBenefits: accessLevel.includedBenefitsCollection?.items,
      excludedBenefits: accessLevel.excludedBenefitsCollection?.items,
    };
  }

  return base;
}
